import React from "react";
import ArrowLeftSvg from "../../../../assets/taiga-uikit/icons/arrow-left-1.svg?react";
import { Text } from "../../../../components/texts/text";
import { _sizeText } from "../../../../core/core";
import "./Category.css";

interface CategoryProps {
  id?: string;
  image?: string | null;
  alt?: string | null;
  children: React.ReactNode;
}

export const CategoryView: React.FC<CategoryProps> = ({
  id,
  image,
  alt,
  children,
}) => {
  return (
    <>
      <div key={id} className="fast-service-body">
        {image && (
          <img
            height="24"
            width="24"
            src={image}
            alt={alt || "Category Image"}
          />
        )}
        <div className="fast-service-title">
          <Text size={_sizeText.m}>{children}</Text>
        </div>
      </div>
      <ArrowLeftSvg />
    </>
  );
};
